import { fetchEventSource } from "@microsoft/fetch-event-source";

export const streamChat = async (
  message,
  conversationId,
  requestId,
  onChunk,
  onError,
  onComplete
) => {
  const API_URL = process.env.REACT_APP_DOORSHARP_CHAT_API_URL;
  const API_KEY = process.env.REACT_APP_DOORSHARP_CHAT_API_KEY;

  if (!API_URL) {
    throw new Error("REACT_APP_DOORSHARP_CHAT_API_URL is undefined");
  }

  const controller = new AbortController();

  fetchEventSource(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "text/event-stream",
      "Ocp-Apim-Subscription-Key": API_KEY,
    },
    body: JSON.stringify({
      message,
      conversation_id: conversationId,
      request_id: requestId,
    }),
    signal: controller.signal,

    onopen(response) {
      const contentType = response.headers.get("content-type");
      if (!contentType?.includes("text/event-stream")) {
        throw new Error(
          `Expected content-type text/event-stream, got ${contentType}`
        );
      }
    },

    onmessage(event) {
      if (!event.data) return;

      try {
        const parsed = JSON.parse(event.data);

        /**
         * Backend may either:
         *  - wrap the block in `payload`, or
         *  - send the rich/simple structure at the top level (what we're seeing now)
         *
         * Normalise so downstream code always gets a usable payload object.
         */
        const payload = parsed.payload ?? parsed;

        onChunk(
          payload,
          parsed.conversation_id,
          parsed.request_id,
          parsed.timestamp
        );
      } catch (e) {
        console.warn("Invalid SSE payload:", event.data);
      }
    },

    onerror(err) {
      onError(err);
      throw err;
    },

    onclose() {
      onComplete();
    },
  });

  return () => controller.abort();
};
